import { render, staticRenderFns } from "./InfoForm.vue?vue&type=template&id=3a031222&scoped=true"
import script from "./InfoForm.vue?vue&type=script&lang=js"
export * from "./InfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a031222",
  null
  
)

export default component.exports